import * as yup from "yup"

export const validationSchema = yup.object().shape({
  qty_received: yup.number().label("Quantity").required(),
  qty_order: yup.number().label("Quantity").required().when('qty_received', (value: any, schema) => {
    return schema.min(value, 'Quantity must not smaller than Received Quantity');
  })
})

export type FormType = yup.InferType<typeof validationSchema>